import { DeleteOutline } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./Stock.css";
import supplierImg from "../../assets/svg/defultImage.svg";
import CameraIcon from "../../assets/svg/Camera icon.svg";
import axios from "axios";
import def from "../../assets/svg/defultImage.svg";
import { toast } from "react-toastify";
import DeleteModal from "../../components/Modals/DeleteModal";
import { useSelector } from "react-redux";

const BASE_URL = "https://estbn.com/EstbnNew/public";

const Supplier_Profile = () => {
  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newHeaders = {
    Authorization: "Bearer " + token,
  };

  const { id } = useParams();
  const [supplier, setSupplier] = useState({});

  const [uploadedFiles, setUploadedFiles] = useState([]);

  const [imagePreview, setImagePreview] = useState(null);
  const [uploadedImage, setUploadedimage] = useState(null);
  const [showDeleteImage, setShowDeleteImage] = useState(false);
  const [imageId, setImageId] = useState(null);

  const fetchSupplier = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/portal/providers/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const fetchedSupplier = response.data?.data?.provider;

      if (fetchedSupplier) {
        setSupplier(fetchedSupplier);
      }
    } catch (error) {
      console.error("Error fetching supplier:", error);
    }
  };

  useEffect(() => {
    fetchSupplier();
  }, []);

  useEffect(() => {
    return () => {
      uploadedFiles.forEach((item) => URL.revokeObjectURL(item.preview));
    };
  }, [uploadedFiles]);

  const FileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
        setUploadedimage(file);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSaveAttachments = async () => {
    const formData = new FormData();
    formData.append("image_url", uploadedImage);
    try {
      const response = await axios.post(
        `${BASE_URL}/api/portal/providers/${id}/images`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response);
      fetchSupplier();
      setImagePreview(null);
      toast.success(response.data.data?.message);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  };

  const handleDeleteImageShow = (id) => {
    setShowDeleteImage(true);
    setImageId(id);
  };

  const handleDeleteImageClose = () => {
    setShowDeleteImage(false);
  };

  const DeleteImage = async () => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/api/portal/providers/${id}/images/${imageId}`,
        {
          headers: newHeaders,
        }
      );
      toast.success(response.data?.data.message);
      fetchSupplier();
      setShowDeleteImage(false);
    } catch (error) {
      toast.error(error.response.data?.message);
    }
  };

  const mainBranch = supplier.branches?.[0];
  const address = mainBranch?.address;
  const services = supplier.services || [];
  const fetchedAttachments = supplier.images || [];

  return (
    <>
      <DeleteModal
        showDelete={showDeleteImage}
        handleDeleteClose={handleDeleteImageClose}
        textMessage={" Are you sure you want to delete this Image?"}
        deleteFunction={DeleteImage}
      />
      <div className="p-4 border rounded-2 my-1 min-vh-100">
        <div className="d-flex justify-content-between align-items-center">
          <h4>Profile</h4>
        </div>
        <div className="my-3">
          <h6 className="fw-bold my-4 mx-2">1. Company Info :</h6>
          <div className="upload-file-responsive">
            <p className="spplier-profile-label-color m-0 p-0 fw-medium supplier-label-size">
              Company Logo
            </p>
            <img
              src={
                supplier.logo_url
                  ? `${BASE_URL}${supplier.logo_url}`
                  : supplierImg
              }
              alt={`${supplier.name || "Supplier"} Logo`}
              style={{ maxWidth: "150px", height: "auto" }}
            />
          </div>
          <div className="d-flex align-items-center mt-4 mx-2 custom-card-sm ">
            <h6 className="spplier-profile-label-color">Company Name:</h6>
            <h6 className="ms-2 fw-semibold">{supplier.name || ""}</h6>
          </div>
          <div className="d-flex align-items-center my-3 mx-2 custom-card-sm">
            <h6 className="spplier-profile-label-color">Username:</h6>
            <h6 className="ms-2 fw-semibold">{supplier.username || ""}</h6>
          </div>
          <div className="d-flex align-items-center mb-4 mx-2 custom-card-sm">
            <h6 className="spplier-profile-label-color m-0">Website link:</h6>
            {supplier.website ? (
              <a
                href={supplier.website}
                target="_blank"
                rel="noopener noreferrer"
                className="text-dark text-decoration-underline fw-semibold ms-2"
              >
                {supplier.website}
              </a>
            ) : (
              <h6 className="text-dark fw-semibold ms-2 m-0 ">-</h6>
            )}
          </div>
          <h6 className="fw-bold my-4 mx-2 ">2. Services :</h6>
          {services.length > 0 ? (
            <div className="d-flex align-items-center my-2 gap-5 flex-wrap mx-2 custom-card-sm">
              {services.map((service, index) => (
                <div
                  key={service.id || `service-${index}`}
                  className="d-flex align-items-center gap-1"
                >
                  <img
                    src={
                      service.image
                        ? `${BASE_URL}${service?.image?.image_url}`
                        : def
                    }
                    alt={`${service.name || "Service"} icon`}
                    style={{ width: "24px", height: "24px" }}
                  />
                  <p className="m-0 spplier-profile-label-color fw-semibold">
                    {service.name || ""}
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <p className="mx-2 spplier-profile-label-color">
              No services available.
            </p>
          )}
          <h6 className="fw-bold my-4 mx-2">3. Branches:</h6>
          <div className="d-flex align-items-center mb-4 mx-2 custom-card-sm ">
            <h6 className="spplier-profile-label-color mx-2">Main Branch:</h6>
            <h6 className="text-dark fw-semibold">{mainBranch?.name || " "}</h6>
          </div>
          <div className="d-flex align-items-center mb-4 mx-2 custom-card-sm">
            <h6 className="spplier-profile-label-color mx-2">Address:</h6>
            <h6 className="text-dark fw-semibold">{address?.address || " "}</h6>
          </div>
          <div className="d-flex align-items-center mb-4 mx-2 custom-card-sm">
            <h6 className="spplier-profile-label-color mx-2">Landmark:</h6>
            <h6 className="text-dark fw-semibold">
              {address?.landmark || " "}
            </h6>
          </div>
          <h6 className="fw-bold my-4 mx-2">4. Attachments (Documents):</h6>
          <div className="row">
            {fetchedAttachments?.map((providerImage) => (
              <div
                style={{ minHeight: "200px", position: "relative" }}
                className="col-md-3 col-sm-12 image-card"
              >
                <div
                  onClick={() => handleDeleteImageShow(providerImage.id)}
                  className="delete-icon"
                >
                  <DeleteOutline color="error" fontSize="small" />
                </div>
                <div
                  style={{ width: "200px", height: "180px" }}
                  className="d-flex justify-content-center align-items-center gap-2 my-1"
                >
                  <img
                    className="w-100 h-100 rounded-3"
                    src={`${BASE_URL}${providerImage?.image_url}`}
                    alt=""
                  />
                </div>
              </div>
            ))}
            <div className="col-md-3 col-sm-12">
              {/* <h6 className=" spplier-profile-label-color text-center">Profile Image</h6> */}
              <label htmlFor="profile-img" className="w-100">
                <div className="profile-img-box  d-flex align-items-center justify-content-center">
                  <div className="">
                    {imagePreview ? (
                      <img className="w-100 h-100" src={imagePreview} alt="" />
                    ) : (
                      <>
                        <img src={CameraIcon} alt="" />

                        <h6 className="m-0">Add Pic</h6>
                      </>
                    )}

                    <input
                      id="profile-img"
                      className="d-none"
                      type="file"
                      onChange={FileChange}
                    />
                  </div>
                </div>
              </label>
            </div>
          </div>
          <div className="d-flex justify-content-center my-3">
            <button
              onClick={handleSaveAttachments}
              className="btn btn-dark px-5"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Supplier_Profile;
